import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

import { getLoggedInUser, getIncludedInGroups } from 'reducers';
import {
  fetchUsersAnalytics,
  fetchSubscriptionsAnalytics,
  fetchPlansAnalytics,
} from '../api';

const withReportingAnalytics = (DecoratedComponent) => {
  class WithReportingAnalytics extends Component {
    state = {
      usersAnalyticsLoading: false,
      subscriptionsAnalyticsLoading: false,
      plansAnalyticsLoading: false,
      usersAnalytics: null,
      subscriptionsAnalytics: null,
      plansAnalytics: null,
    };

    componentDidMount() {
      this.fetchUsersAnalytics();
      this.fetchSubscriptionsAnalytics();
      this.fetchPlansAnalytics();
    }

    fetchUsersAnalytics() {
      this.setState({ usersAnalyticsLoading: true });
      fetchUsersAnalytics()
        .then((res) => {
          this.setState({
            usersAnalytics: res.data,
          });
        })
        .catch((e) => toast.error('Failed to load users analytics'))
        .finally(() => this.setState({ usersAnalyticsLoading: false }));
    }

    fetchSubscriptionsAnalytics() {
      this.setState({ subscriptionsAnalyticsLoading: true });
      fetchSubscriptionsAnalytics()
        .then((res) => {
          this.setState({
            subscriptionsAnalytics: res.data,
          });
        })
        .catch((e) => toast.error('Failed to load subscriptions analytics'))
        .finally(() => this.setState({ subscriptionsAnalyticsLoading: false }));
    }

    fetchPlansAnalytics() {
      this.setState({ plansAnalyticsLoading: true });
      fetchPlansAnalytics()
        .then((res) => {
          this.setState({
            plansAnalytics: res.data,
          });
        })
        .catch((e) => toast.error('Failed to load plans analytics'))
        .finally(() => this.setState({ plansAnalyticsLoading: false }));
    }

    render() {
      const { children, ...props } = this.props;
      const {
        usersAnalyticsLoading,
        subscriptionsAnalyticsLoading,
        plansAnalyticsLoading,
        usersAnalytics,
        subscriptionsAnalytics,
        plansAnalytics,
      } = this.state;
      const childProps = {
        usersAnalyticsLoading,
        subscriptionsAnalyticsLoading,
        plansAnalyticsLoading,
        usersAnalytics,
        subscriptionsAnalytics,
        plansAnalytics,
        ...props,
      };
      return React.createElement(DecoratedComponent, childProps, children);
    }
  }

  const mapStateToProps = (state) => {
    const isAdminOrManager = getIncludedInGroups(state, ['ADMIN', 'MANAGER']);
    const loggedInUser = getLoggedInUser(state);

    return {
      isAdminOrManager,
      loggedInUser,
    };
  };

  const mapDispatchToProps = {};

  return connect(mapStateToProps, mapDispatchToProps)(WithReportingAnalytics);
};

export default withReportingAnalytics;
